import { searchOrgsSegments } from 'modules/search/routing/search.route-segments';
import { searchOrgRouteReference } from 'modules/search/routing/search.routes';
import { SearchOrgFiltersByName } from 'modules/search/types/FiltersByName/SearchOrgFiltersByName';
import { SearchSortType } from 'modules/search/types/SearchSortType';

import { searchGetQueryParamsFromFiltersByName } from './searchGetQueryParamsFromFiltersByName';

type Args = {
  lang: UserLocale;
  q?: string;
  radius?: 'state' | 'country' | string | null;
  filtersByName?: Omit<SearchOrgFiltersByName, 'type'>;
  sort?: SearchSortType;
  pageIndex?: number;
};

export function searchGetOrgsRoutePath({
  lang,
  filtersByName,
  q,
  radius,
  sort,
  pageIndex,
}: Args) {
  const segment = searchOrgsSegments[lang];

  const queryParams = searchGetQueryParamsFromFiltersByName(filtersByName);

  if (q) queryParams.q = q;
  if (radius) queryParams.radius = radius;
  if (sort && sort !== 'relevance') queryParams.sort = sort;
  if (pageIndex) queryParams.page = pageIndex + 1;

  return searchOrgRouteReference.with({
    lang,
    segment,
    ...queryParams,
  });
}
